export const fappSubscriptions = [
    ...process.env.NODE_ENV === 'development' ? [console.log] : [],
];
